import { publicConfigValue } from "@/lib/public-config";


const urlCache = new Map<string, string>()

export function getBaseUrl(): string {
  if (publicConfigValue("NEXT_PUBLIC_ENVIRONMENT") === 'production') {
    return 'https://www.repackify.com'
  }
  return publicConfigValue("NEXT_PUBLIC_APP_URL") || 'http://localhost:3000'
}

export function getCanonicalUrl(path: string): string {
  if (typeof path !== 'string') {
    console.warn('canonical.url.invalid_path', { pathType: typeof path })
    path = String(path || '')
  }

  const cacheKey = `canonical:${path}`
  if (urlCache.has(cacheKey)) {
    return urlCache.get(cacheKey)!
  }

  const baseUrl = getBaseUrl()

  let cleanPath = path.startsWith('/') ? path.slice(1) : path
  cleanPath = cleanPath.replace(/\/$/, '')

  const canonicalUrl = !cleanPath ? baseUrl : `${baseUrl}/${cleanPath}`

  urlCache.set(cacheKey, canonicalUrl)

  return canonicalUrl
}

export function normalizeParam(param: string): string {
  return param
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
}

export function getDynamicRelativeCanonicalUrl(segments: string[]): string {
  const normalizedSegments = segments.map(normalizeParam).filter(Boolean)
  const path = normalizedSegments.join('/')
  return getRelativeCanonicalUrl(path)
}

export function getAbsoluteCanonicalUrl(path: string): string {
  return getCanonicalUrl(path)
}

export function getRelativeCanonicalUrl(path: string): string {
  let cleanPath = path.startsWith('/') ? path.slice(1) : path
  cleanPath = cleanPath.replace(/\/$/, '')

  if (!cleanPath) {
    return '/'
  }

  return `/${cleanPath}`
}
